import { PollsViewStatuses } from '../../constans/polls-constants';
import ResponseEntity from '../../store/polls-store/response-entity';

type MappedObject = { [key: string]: string };

export const convertStatusIntoClassName = (status: PollsViewStatuses): string => {
  return status.replace(' ', '-').toLowerCase();
};

export const getKeyByValue = (obj: MappedObject, value: string): string => {
  return Object.keys(obj).find((key: string) => obj[key] === value) || '';
};

export const sortByOrder = (arr: ResponseEntity[]): ResponseEntity[] => {
  return arr.sort((a: ResponseEntity, b: ResponseEntity) => a.order - b.order);
};

interface FullScreenElement extends HTMLDivElement {
  webkitRequestFullscreen?: () => Promise<void>;
  msRequestFullscreen?: () => Promise<void>;
  mozRequestFullScreen?: () => Promise<void>;
}

// @ts-ignore
export const openFullscreen = (elem: FullScreenElement): Promise<unknown> => {
  if (elem.requestFullscreen) {
    return elem.requestFullscreen();
  } else if (elem.webkitRequestFullscreen) {
    return elem.webkitRequestFullscreen();
  } else if (elem.msRequestFullscreen) {
    return elem.msRequestFullscreen();
  }else if (elem.mozRequestFullScreen) {
    return elem.mozRequestFullScreen();
  }
};